/**
 * Config-driven notification triggers.
 * Add new entries here as more trigger APIs ship — the hub page renders them automatically.
 */
export const NOTIFICATION_TRIGGERS = [
  {
    id: "whatsapp-dispatch",
    title: "WhatsApp Dispatch Notification",
    description:
      "Send WhatsApp updates for lensware orders marked DISP. Runs in the background after you confirm.",
    icon: "whatsapp",
    accent: "#25D366",
    actionLabel: "Send Dispatch Updates",
    confirmTitle: "Send dispatch updates?",
    confirmContent:
      "This will register WhatsApp notifications for lensware status DISP. Delivery runs in the background — you will not wait for send results on this call.",
    available: true,
    buildPayload: () => ({
      notification_type: "lensware_status",
      lensware_status: ["DISP"],
    }),
  },
];
